import { render, staticRenderFns } from "./InstitutionRow.vue?vue&type=template&id=2f52bc66&scoped=true&"
import script from "./InstitutionRow.vue?vue&type=script&lang=js&"
export * from "./InstitutionRow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/listrows.css?vue&type=style&index=0&id=2f52bc66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52bc66",
  null
  
)

export default component.exports